{
  "version": "2.5.13",
  "build": 354,
  "date": "2026-10-27"
}
